import { render, staticRenderFns } from "./AdminEventRate.vue?vue&type=template&id=5d2c5ab0&"
import script from "./AdminEventRate.vue?vue&type=script&lang=js&"
export * from "./AdminEventRate.vue?vue&type=script&lang=js&"
import style0 from "./AdminEventRate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports